<!--レイヤーメニューコンポーネント-->
<!--templatesのvue関連項目名を変更したら一度、templateの中身を以下にコピー後、動作確認後、再度元に戻す-->
<template src="./templates/LayerMenuTemplate.html">
</template>

<script>
// import LayerMenuTemplate from './templates/LayerMenuTemplate.vue';
// import LegendMenu from './LegendMenu.vue'

// アコーディオンメニュー
var accordion = {
	props: [
		'title',
		'menutype'
	],
	data() {
		return {
			active: false,
		disp_pos: 0,
		shindoLayer:"L102",
		ekijyoukaLayer:"L112",
		showeKen:false
		}
	},
	template: `
		<div class="">
		<!--フッターのレイヤー一覧開閉 -->
			<div class="tab__header" style="padding:0px 0px;"	v-if="menutype==='bottom'">
				<a href="#" class="tab__link p-1 block bg-blue-dark hover:bg-blue-darker no-underline text-sm text-white border-b-2 border-white flex justify-between" @click="closeAllLayerMenu" @click.prevent="active = !active">
				<span style="white-space:pre-line;">{{title}}</span>
					<!--
					<span class="down-Arrow" v-show="!active">開く</span>
					<span class="up-Arrow" v-show="active">閉じる</span>
					-->
					<span class="down-Arrow" v-show="!active"><i class="fa fa-plus"></i></span>
					<span class="up-Arrow" v-show="active"><i class="fa fa-minus"></i></span>
				</a>
			</div>
			<!--ヘッダーーのレイヤー一覧 -->
			<div class="tab__header" style="padding:0px 0px;"	v-else-if="menutype==='head'">
<!--				<a href="#" class="tab__link p-1 block bg-blue-dark hover:bg-blue-darker no-underline text-sm text-white border-b-2 border-white flex justify-between" @click="closeLayerMenu">-->
					<span class="p-1 block bg-blue-dark no-underline text-sm text-white border-b-2 border-white flex justify-between">
						表示中:{{title}}
					</span>
<!--			</a>	-->
			</div>
			<!--個別レイヤーチェックボックス -->
			<div class="tab__header" style="padding:0px 0px;"	v-else-if="menutype==='sub'">
				<slot name="ckbLayer"></slot>
				<label for="box1">
					<a href="#" class="tab__link p-1 block bg-blue-dark hover:bg-blue-darker no-underline text-sm text-black flex justify-between" @click.prevent="active = !active">
						<!--
						<span class="down-Arrow" v-show="!active">&#9660;</span>
						<span class="up-Arrow" v-show="active">&#9650;</span>
						-->
						<span class="down-Arrow" v-show="!active"><i class="fa fa-plus"></i></span>
						<span class="up-Arrow" v-show="active"><i class="fa fa-minus"></i></span>
						<span style="white-space:pre-line;">{{title}}</span>
					</a>
				</label>
			</div>
			<!--震度個別レイヤーチェックボックス -->
			<div class="tab__header" style="padding:0px 0px;"	v-else-if="menutype==='subshindo'">
				<slot name="ckbLayer"></slot>
				<label for="box1">
					<a href="#" class="tab__link p-1 block bg-blue-dark hover:bg-blue-darker no-underline text-sm text-black flex justify-between" @click.prevent="active = !active">
						<!--
						<span class="down-Arrow" v-show="!active">&#9660;</span>
						<span class="up-Arrow" v-show="active">&#9650;</span>
						-->
						<span class="down-Arrow" v-show="!active"><i class="fa fa-plus"></i></span>
						<span class="up-Arrow" v-show="active"><i class="fa fa-minus"></i></span>
						<span style="white-space:pre-line;">{{title}}</span>
					</a>
				</label>
				<div v-show="showeKen">
					<ul class="list-group text-black">
						<li class="li-padding bg-blue-dark text-left text-sm">
						<input type="radio" v-model="shindoLayer" id="L101" value="L101" v-on:change="changeShindoLayer($event)"/>
						<label for="box1">県のデータを表示</label>
						</li>
					</ul>
					<ul class="list-group text-black">
						<li class="li-padding bg-blue-dark text-left text-sm">
						<input type="radio" v-model="shindoLayer" id="L102" value="L102" v-on:change="changeShindoLayer($event)"/>
						<label for="box1">市町村のデータを表示</label>
						</li>
					</ul>
				</div>
			</div>
			<!--液状化個別レイヤーチェックボックス -->
			<div class="tab__header" style="padding:0px 0px;"	v-else-if="menutype==='subekijyouka'">
				<slot name="ckbLayer"></slot>
				<label for="box1">
					<a href="#" class="tab__link p-1 block bg-blue-dark hover:bg-blue-darker no-underline text-sm text-black flex justify-between" @click.prevent="active = !active">
						<!--
						<span class="down-Arrow" v-show="!active">&#9660;</span>
						<span class="up-Arrow" v-show="active">&#9650;</span>
						-->
						<span class="down-Arrow" v-show="!active"><i class="fa fa-plus"></i></span>
						<span class="up-Arrow" v-show="active"><i class="fa fa-minus"></i></span>
						<span style="white-space:pre-line;">{{title}}</span>
					</a>
				</label>
				<div v-show="showeKen">
					<ul class="list-group text-black">
						<li class="li-padding bg-blue-dark text-left text-sm">
						<input type="radio" v-model="ekijyoukaLayer" id="L111" value="L111" v-on:change="changeEkijyoukaLayer($event)"/>
						<label for="box1">県のデータを表示</label>
						</li>
					</ul>
					<ul class="list-group text-black">
						<li class="li-padding bg-blue-dark text-left text-sm">
						<input type="radio" v-model="ekijyoukaLayer" id="L112" value="L112" v-on:change="changeEkijyoukaLayer($event)"/>
						<label for="box1">市町村のデータを表示</label>
						</li>
					</ul>
				</div>
			</div>
			<!--各レイヤー開閉 -->
			<div class="tab__header" style="padding:0px 0px;" v-else>
				<a href="#" class="tab__link p-1 block bg-blue-dark hover:bg-blue-darker no-underline text-sm text-white border-b-2 border-white flex justify-between" @click.prevent="active = !active">
				<span style="white-space:pre-line;">{{title}}</span>
					<!--
						<span class="down-Arrow" v-show="!active">&#9660;</span>
						<span class="up-Arrow" v-show="active">&#9650;</span>
					-->
						<span class="down-Arrow" v-show="!active"><i class="fa fa-plus"></i></span>
						<span class="up-Arrow" v-show="active"><i class="fa fa-minus"></i></span>
				</a>
			</div>
			<div class="tab__content" v-show="active"><slot /></div>
		</div>
	`,
		// <div class="tab__content p-2" v-show="active"><slot /></div>
	methods: {
		//ボタンをクリックするとこのメソッドが起動する 
		closeLayerMenu: function(){
		console.log('layer menu accordion closeLayerMenu!!');
			this.$emit('closeLayerMenuNotify');//親へイベント発火を伝える
		},
		closeAllLayerMenu: function(){
		console.log('layer menu accordion closeLayerMenu!!');
			this.$emit('closeAllLayerMenuNotify');//親へイベント発火を伝える
		},
		//名古屋市、県ラジオボックスの表示非表示
		//App=>LayerMenu=>accordionで呼び出される
		dispKenRadio: function(kenFlg){
	 		this.showshindo = !kenFlg;
			this.showekijyouka = !kenFlg;
			this.showeKen = !kenFlg;
		//	 //県の場合は県レイヤのみ
		//	 if (kenFlg){
		// 	this.shindoLayer = 'L101'
		// 	this.ekijyoukaLayer = 'L111'
		//	 }
			console.log('accordion 県フラグshoweKen：'+this.showeKen)
		//	 this.$refs.shindoMenu.dispKenRadio(kenFlg);
		},
		getShindoLayer: function(){
			console.log('accordion shindoLayer:'+this.shindoLayer);
			return this.shindoLayer;
		},
		getEkijyoukaLayer: function(){
			console.log('accordion ekijyoukaLayer:'+this.ekijyoukaLayer);
			return	this.ekijyoukaLayer;
		},
		changeShindoLayer: function(event) {
			console.log('accordion changeShindoLayer:'+this.shindoLayer);
				this.$emit('shindoCheck', this.shindoLayer);//親へイベント発火を伝える
		},
		changeEkijyoukaLayer: function(event) {
			console.log('accordion changeEkijyoukaLayer:'+this.ekijyoukaLayer);
				this.$emit('ekijyoukaCheck', this.ekijyoukaLayer);//親へイベント発火を伝える
		},
	}
}


export default {
	name: 'LayerMenu',
//	 template: '<LayerMenuTemplate>',
	components: {
		// LayerMenuTemplate,
	 	// LegendMenu,
		accordion
	},
	props: [
		'layerMenuPos'
	],
//	 props:{
// 	'layerMenuPos': {
// 		type: String,
// 		required: true
// 	}
//	 },
	data () {
		return {
			message: "test!!",
			searchingflagR:true,		// 検索リクエスト重複を防ぐフラグ
			checkedLayers: [],	//レイヤー一覧
			checkedAllLayers: [],	//レイヤー一覧
			aaa:true,
			backgroundLayers:["L001","L002","L003"],
			backgroundLayer:"L001",
			//backgroundLayer:"L001",
			showAllLayerMenu:false,
			//レイヤメニューのスタイル
			lmenustyle: {
				position: 'absolute',
				bottom: '65px',
				left: '10px',
				padding: '1px',
				width: '25%',
			//	 'overflow-y':'scroll',
			//	 'max-height': '90%',
				'max-height':'90vh'
			},
			rmenustyle: {
				position: 'absolute',
				bottom: '65px',
				right: '10px',
				padding: '1px',
				width: '25%',
			//	 'overflow-y':'scroll',
			//	 'max-height': '90%',
				'max-height':'90vh'
			},
			menuClass:"LayerMenu",
		//	 menuWidthClass:"position-absolute bg-primary text-white w-25",
			menuWidthClass:"position-absolute bg-primary text-white",
			showPc:true,
			showMobile:false,
			dispLayerNames:"地図",
			dicBaseLayers:{},
			dicLayers:{},
			kenFlg:true
		}
	},
	mounted: function() {
		console.log('LayerMenu checkedLayers:' + this.checkedLayers);
	},
	methods: {
		created: function() {
		},
	// ForcechangeLayer:function(layer){
		ForcechangeLayer(layer){
			if ((layer ==='L101')||(layer ==='L102')){
				this.checkedAllLayers = this.checkedAllLayers.filter(item => item != 'L101' && item != 'L102');
				this.checkedAllLayers.push(layer)
			}
			if ((layer ==='L111')||(layer ==='L112')){
				this.checkedAllLayers = this.checkedAllLayers.filter(item => item != 'L111' && item != 'L112');
				this.checkedAllLayers.push(layer)
			}
			//チェック済みレイヤーをタイトル表示
			var wkCheckedLayers = this.checkedLayers.concat(this.checkedAllLayers);
			wkCheckedLayers = wkCheckedLayers.filter(item => item != 'L100' && item != 'L110');

			wkCheckedLayers.sort();
			this.dispLayerNames = '';
			this.dispLayerNames = this.dispLayerNames + this.dicBaseLayers[this.backgroundLayer] + ',';
			wkCheckedLayers.forEach(ckLayer => {
				if (this.dicLayers[ckLayer]) {
					console.log(this.dicLayers[ckLayer]);
					this.dispLayerNames = this.dispLayerNames + this.dicLayers[ckLayer] + ',';
				}
			});
			this.dispLayerNames = this.dispLayerNames.slice( 0, -1 ) ;
		},
		shindoCheck:function(id){
			//チェック済みならcheckedAllLayersのL101,L102削除し、checkedAllLayersにvalをいれて、レイヤ表示changeLayer call ????
			//console.log('checkedAllLayers'+this.checkedAllLayers);
			var idx = 0;
			//checkedAllLayersから震度を全部削除
			if (this.checkedLayers.indexOf('L100')!=-1){
				//リストから震度削除
				idx = this.checkedAllLayers.indexOf('L101');
				if(idx >= 0){
					this.checkedAllLayers.splice(idx, 1); 
					//対象レイヤ非表示
					// this.$emit('checkedLayer',{value:'L101',display:false});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L101',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L102',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
				}
				idx = this.checkedAllLayers.indexOf('L102');
				if(idx >= 0){
					this.checkedAllLayers.splice(idx, 1); 
					//対象レイヤ非表示
					// this.$emit('checkedLayer',{value:'L102',display:false});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L101',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L102',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
				}
				//選択された値をリストに追加
				this.checkedAllLayers.push(id);
				//対象レイヤ表示
				// this.$emit('checkedLayer',{value:id,display:true});//親へイベント発火を伝える
				this.$emit('checkedLayer',{value:id,display:true,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
	
				//チェック済みレイヤーをタイトル表示
				// console.log('shindoCheck checkedAllLayers'+this.checkedAllLayers);
				var wkCheckedLayers = this.checkedLayers.concat(this.checkedAllLayers);
				wkCheckedLayers = wkCheckedLayers.filter(item => item != 'L100' && item != 'L110');
	
				wkCheckedLayers.sort();
				this.dispLayerNames = '';
				this.dispLayerNames = this.dispLayerNames + this.dicBaseLayers[this.backgroundLayer] + ',';
				wkCheckedLayers.forEach(ckLayer => {
					if (this.dicLayers[ckLayer]) {
						console.log(this.dicLayers[ckLayer]);
						this.dispLayerNames = this.dispLayerNames + this.dicLayers[ckLayer] + ',';
					}
				});
				this.dispLayerNames = this.dispLayerNames.slice( 0, -1 ) ;
				console.log('shindoCheck dispLayerNames:'+this.dispLayerNames);
			}
			console.log('menu shindoCheck：'+this.checkedAllLayers)
			console.log('menu id'+id)
			//選択されているラジオボタンを値を親に通知する
			this.$emit('shindoMenuLayer',{Layer:id});//親へイベント発火を伝える
		},
		ekijyoukaCheck:function(id){
			//チェック済みならcheckedAllLayersのL111,L112削除し、checkedAllLayersにvalをいれて、レイヤ表示changeLayer call ????
			console.log('checkedAllLayers'+this.checkedAllLayers);
			console.log('ekijyoukaCheck id:'+id)
			var idx = 0;
			//checkedAllLayersから震度を全部削除
			if (this.checkedLayers.indexOf('L110')!=-1){
				//リストから震度削除
				idx = this.checkedAllLayers.indexOf('L111');
				if(idx >= 0){
					this.checkedAllLayers.splice(idx, 1); 
					//対象レイヤ非表示
					// this.$emit('checkedLayer',{value:'L111',display:false});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L111',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L112',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
				}
				idx = this.checkedAllLayers.indexOf('L112');
				if(idx >= 0){
					this.checkedAllLayers.splice(idx, 1); 
					//対象レイヤ非表示
					// this.$emit('checkedLayer',{value:'L112',display:false});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L111',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L112',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
				}
				//選択された値をリストに追加
				this.checkedAllLayers.push(id);
				//対象レイヤ表示
				// this.$emit('checkedLayer',{value:id,display:true});//親へイベント発火を伝える
				this.$emit('checkedLayer',{value:id,display:true,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
	
				//チェック済みレイヤーをタイトル表示
				console.log('checkedAllLayers'+this.checkedAllLayers);
				var wkCheckedLayers = this.checkedLayers.concat(this.checkedAllLayers);
				wkCheckedLayers = wkCheckedLayers.filter(item => item != 'L100' && item != 'L110');
	
				wkCheckedLayers.sort();
				this.dispLayerNames = '';
				this.dispLayerNames = this.dispLayerNames + this.dicBaseLayers[this.backgroundLayer] + ',';
				wkCheckedLayers.forEach(ckLayer => {
					if (this.dicLayers[ckLayer]) {
						console.log(this.dicLayers[ckLayer]);
						this.dispLayerNames = this.dispLayerNames + this.dicLayers[ckLayer] + ',';
					}
				});
				this.dispLayerNames = this.dispLayerNames.slice( 0, -1 ) ;
				console.log('ekijyoukaCheck dispLayerNames:'+this.dispLayerNames);
			}				
			console.log('ekijyoukaCheck checkedAllLayers:'+this.checkedAllLayers)
			//選択されているラジオボタンを値を親に通知する
			this.$emit('ekijyoukaMenuLayer',{Layer:id});//親へイベント発火を伝える
		},
		//現在中央位置が名古屋市、名古屋市以外をAccodionに通知
		//Map=>App=>LayerMenu=>Accodionに通知
		dispKenRadio: function(kenFlg){
			console.log('県フラグ：'+kenFlg)
			this.kenFlg = kenFlg;
			//【注意】$refsを分けている場合は、$refs毎に通知すること
			this.$refs.shindoMenu.dispKenRadio(kenFlg);
			this.$refs.ekijyoukaMenu.dispKenRadio(kenFlg);
		},
		toggleShowLeftAllLayerMenu: function(){
			console.log('LayerMenu toggleShowLeftAllLayerMenu');
			this.showAllLayerMenu = !this.showAllLayerMenu;
		},
		toggleShowRightAllLayerMenu: function(){
			console.log('LayerMenu toggleShowRightAllLayerMenu');
			this.showAllLayerMenu = !this.showAllLayerMenu;
		},
		closeLayerMenuEvent: function(){
			this.$emit('child-event', this.message);//親へイベント発火を伝える
		},
		//ボタンをクリックするとこのメソッドが起動する 
		click: function(){
			this.$emit('child-event', this.message);//親へイベント発火を伝える
		},
		click2: function(){
			this.$emit('child-event', this.message);//親へイベント発火を伝える
		},
		//EelemntID取得用
		getElement: function(id){
			if (document.getElementById){
				return document.getElementById(id);
			}else if(document.all){
				return document.all(id);
			}
		},
		setLayers(dicBaseLayers,dicLayers){
			//console.debug('setLayers'+dicLayers);
			this.dicBaseLayers = JSON.parse(dicBaseLayers)
			this.dicLayers = JSON.parse(dicLayers)
		},
		/**
		 * 「レイヤ一覧」のチェック状態を「表示中レイヤ一覧」に反映する
		 */
		changeLayer: function(event) {
			console.log('before kenFlg:'+this.kenFlg);
			console.log('before id'+event.target.id);
			console.log('before checkedAllLayers'+this.checkedAllLayers);
			var wkid = "";
			if (event.target.id === 'L100'){
				//地震
				//ラジオボタンの状態チェック
				if (this.kenFlg){
					wkid = 'L101';
				}else{
					wkid = this.$refs.shindoMenu.getShindoLayer();
				}
				console.log('wkid:'+wkid);
				if (this.checkedLayers.indexOf(event.target.id)==-1){
					//リストから削除
					var idx = this.checkedAllLayers.indexOf(wkid);
					console.log('リストから削除1');
					if(idx >= 0){
						console.log('リストから削除2');
						this.checkedAllLayers.splice(idx, 1); 
					}				
				}else{
					//リストに追加
					this.checkedAllLayers.push(wkid);
				}
				//チェックが外されたらcheckedAllLayersから削除し震度レイヤを非表示
				if (this.checkedLayers.indexOf(event.target.id)==-1){
					var idx = this.checkedAllLayers.indexOf('L101');
					if(idx >= 0){this.checkedAllLayers.splice(idx, 1);}				
					idx = this.checkedAllLayers.indexOf('L102');
					if(idx >= 0){this.checkedAllLayers.splice(idx, 1);}				
					this.$emit('checkedLayer',{value:'L101',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L102',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
				}
	
			}
			else if (event.target.id === 'L110'){
				//液状化
				//todoラジオボタンの状態チェック
				if (this.kenFlg){
					wkid = 'L111';
				}else{
					wkid = this.$refs.ekijyoukaMenu.getEkijyoukaLayer();
				}
				console.log('wkid:'+wkid);
				if (this.checkedLayers.indexOf(event.target.id)==-1){
					//リストから削除
					var idx = this.checkedAllLayers.indexOf(wkid);
					console.log('リストから削除1');
					if(idx >= 0){
						console.log('リストから削除2');
						this.checkedAllLayers.splice(idx, 1); 
					}				
				}else{
					//リストに追加
					this.checkedAllLayers.push(wkid);
				}
				//チェックが外されたらcheckedAllLayersから削除し液状化レイヤを非表示
				if (this.checkedLayers.indexOf(event.target.id)==-1){
					var idx = this.checkedAllLayers.indexOf('L111');
					if(idx >= 0){this.checkedAllLayers.splice(idx, 1);}				
					idx = this.checkedAllLayers.indexOf('L112');
					if(idx >= 0){this.checkedAllLayers.splice(idx, 1);}				
					this.$emit('checkedLayer',{value:'L111',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
					this.$emit('checkedLayer',{value:'L112',display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
				}
			}
			else{
				wkid = event.target.id
			}
			console.log('after id'+event.target.id);
			console.log('after checkedAllLayers'+this.checkedAllLayers);
	
			//-------------------------------------------
			//選択されているラジオボタンを値を親に通知する
			//-------------------------------------------
			this.$emit('shindoMenuLayer',{Layer:this.$refs.shindoMenu.getShindoLayer()});//親へイベント発火を伝える
			this.$emit('ekijyoukaMenuLayer',{Layer:this.$refs.ekijyoukaMenu.getEkijyoukaLayer()});//親へイベント発火を伝える
	
	
			// if (this.checkedLayers.indexOf(event.target.id)==-1){
			// 	//event.target.idのレイヤーを表示
			// 	this.$emit('checkedLayer',{value:wkid,display:false});//親へイベント発火を伝える
			// }else{
			// 	//event.target.idのレイヤーを非表示
			// 	this.$emit('checkedLayer',{value:wkid,display:true});//親へイベント発火を伝える
			// }
			//チェック済みレイヤーをタイトル表示
			console.log(this.backgroundLayer);
			console.log(this.dicBaseLayers);
			console.log(this.dicLayers);
			console.log(this.checkedLayers);
			console.log(this.checkedAllLayers);
	
			//タイトル表示
			var wkCheckedLayers = this.checkedLayers.concat(this.checkedAllLayers);
			wkCheckedLayers = wkCheckedLayers.filter(item => item != 'L100' && item != 'L110');
	
			wkCheckedLayers.sort();
			this.dispLayerNames = '';
			this.dispLayerNames = this.dispLayerNames + this.dicBaseLayers[this.backgroundLayer] + ',';
			wkCheckedLayers.forEach(ckLayer => {
				if (this.dicLayers[ckLayer]) {
					console.log(this.dicLayers[ckLayer]);
					this.dispLayerNames = this.dispLayerNames + this.dicLayers[ckLayer] + ',';
				}
			});
			this.dispLayerNames = this.dispLayerNames.slice( 0, -1 ) ;
			console.log('changeLayer dispLayerNames:'+this.dispLayerNames);
			if (this.checkedLayers.indexOf(event.target.id)==-1){
				//event.target.idのレイヤーを表示
				this.$emit('checkedLayer',{value:wkid,display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
			}else{
				//event.target.idのレイヤーを非表示
				this.$emit('checkedLayer',{value:wkid,display:true,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
			}
		},
		/**	
		 * 「レイヤ一覧」の背景レイヤーチェック状態を「表示中レイヤ一覧」に反映する
		 */
		 changeBackgroundLayer: function(event,layerMenuPos) {
			var wk_id = '';
			if (this.layerMenuPos == 'right'){
				wk_id = event.target.id.replace('RIGHT', '');
			}else{
				wk_id = event.target.id;
			}
			 
			 //タイトル表示
			var wkCheckedLayers = this.checkedLayers.concat(this.checkedAllLayers);
			wkCheckedLayers = wkCheckedLayers.filter(item => item != 'L100' && item != 'L110');
	
			wkCheckedLayers.sort();
			this.dispLayerNames = '';
			this.dispLayerNames = this.dispLayerNames + this.dicBaseLayers[this.backgroundLayer] + ',';
			wkCheckedLayers.forEach(ckLayer => {
				if (this.dicLayers[ckLayer]) {
					console.log(this.dicLayers[ckLayer]);
					this.dispLayerNames = this.dispLayerNames + this.dicLayers[ckLayer] + ',';
				}
			});
			this.dispLayerNames = this.dispLayerNames.slice( 0, -1 ) ;
			console.log('changeBackgroundLayer dispLayerNames:'+this.dispLayerNames);
	
			for (var value of this.backgroundLayers) {
				if (wk_id==value){
					this.$emit('checkedLayer',{value:wk_id,display:true,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
				//ONのレイヤのみを通知するように変更
				//}else{
				//	this.$emit('checkedLayer',{value:value,display:false,checkedLayers:this.checkedLayers,checkedAllLayers:this.checkedAllLayers});//親へイベント発火を伝える
				}
			}
		},
		//	checkLayer: function(self_id, target_id,event) {
		// 	以下の処理は既存アプリが表示していないようなのでコメント化？
		//	 if(getElement(target_id)){
		//		 var flag = getElement(self_id).checked;
		//		 if(flag) {
		//			 getElement(target_id).style.display = "";
		//		 } else {
		//			 getElement(target_id).style.display = "none";
		//		 }
		//		 redrawUserLayer();
		//	 }
		// },
		// 中心点の属性を取得し、レイヤ自動切り替えメソッドを呼ぶ
		getCenterAttributeR: function() {
		// alert("getCenterAttributeR");
		// if(dojo) {
		// 	if(searchingflagR != true) {
		// 		// 現在の中心点座標からジオメトリ変数を生成
		// 		var c = map2.getCenter();
		// 		var d = 1 / 3600000;//1ミリ秒
		// 		var bbox = [(c.lon-d),(c.lat-d),(c.lon+d),(c.lat+d)];

		// 		searchingflagR = true;		// 検索リクエスト実行
		// 		// 属性値を取得してcallback関数に渡す
		// 		map2.requestAttributeSearch(layerChangeAutoR,bbox,null,null,["23000000"]);
		// 	} else {		// 検索リクエストが重複したらTimerで待つ
		// 		return false;
		// 	}
		// }
		}
	}
}

//===============================
//とりあえずscript_r.jsを全部コピー start
//===============================
//EelemntID取得用
function getElement(id){
	if (document.getElementById){
		return document.getElementById(id);
	}else if(document.all){
		 return document.all(id);
	}
}


//地図ドラッグ時の自動処理呼び出し関数：addOnLoadで呼び出す
var traceflagR = false;
function tracetoggleR() {
	//var objmap = MyMapOP.Properties.Map;
	var objmap = map2._map;
	if (objmap) {
		if (!traceflagR) {
			objmap.events.register("moveend", objmap, dragActionR);
			//シナリオモードEnterキー入力対応
			objmap.events.register("mouseup", objmap, focusHoldR);

			traceflagR = true;
		} else {
			objmap.events.remove("moveend", objmap.map);
			traceflagR = false;
		}
	}
}


var centerMemR; // ループ防止：前回メソッド呼び出し時の中心座標を保持
function dragActionR() {		//地図ドラッグ後の自動処理を記述
	/*
	 * ループ防止：中心点が前回のメソッド呼び出し時と
	 * 変わっていなければ再度移動しない
	**/
	var centerCurR = map2.getCenter();		// 現在の中心座標を取得

	// 中心座標が前回のメソッド呼び出し時から動いている（ループでない）
	if(centerCurR != centerMemR){
		// 今回の中心座標を保持する：ループ防止
		centerMemR = centerCurR;

		// 中心点の属性を取得し、レイヤ自動切り替えメソッドを呼ぶ
		getCenterAttributeR();
		
		// 右マップに連動して左マップを移動
		if(parent.rendou_flug) {
			parent.map1.setCenter(map2.getCenterLon(),map2.getCenterLat());
		}

		// 縮尺は有無を言わさず連動
		parent.map1.setScaleLevel(map2.getScaleLevel());
		// スケールバーも連動
		parent.scaleNum = map2.getScaleLevel();

		//以下は不要
		//parent.getElement("scaleBarArr").style.left = String((Number(parent.scaleNum) - 1) * 10 + 5) + "px";
		//parent.getElement("scaleBarArr").style.left = String((Number(parent.scaleNum) - 1) * 10 + 45) + "px";

	}

}





// 新たにドラッグする前の市町村コードを保存する変数（レイヤOFFする時に使う）
var cityCodePre;

// ハザードコードを格納する配列
var hazardCode = new Array("101", "201", "301", "601", "602", "603", "604");


// 中心点の属性に応じてレイヤ関連の自動処理
function layerChangeAutoR(obj) {

	if((obj !== null) && (obj["info"]["nerr"] == 1)) {		// 愛知県かどうかチェック
		searchingflagR = false;		// 検索リクエスト完了
		return false;
	} else {

	//属性から市町村コード取得
	var cityCode = obj["search"][0]["data"][0]["fdata"][0];
	if(cityCode.substr(0,3) == 231) { //名古屋市の場合
		cityCode = 23100;	//区によらず市町村コードは23100に統一
	}

	// おまけ機能2：市町村名を表示
	var subName = decodeURI(obj["search"][0]["data"][0]["fdata"][2]);
	if(subName == "null") {
		subName = "";
	}
	parent.getElement("cityNameR").innerHTML = "|&nbsp&nbsp右：" + subName + decodeURI(obj["search"][0]["data"][0]["fdata"][1]);



	for(var i=0;i<hazardCode.length;i++) {		// ハザードレイヤの数だけループ

		var layerId = String(cityCode) + hazardCode[i];

		//中心点の震度フラグがONかOFFかを判定
		//フラグON
		if(obj["search"][0]["data"][0]["fdata"][(3+i)] == 1) {

			//前回ドラッグ時と比較して市町村コードが変わったかどうか比較
			//（独自レイヤを持つ市町村間の移動に対応）
			if(cityCode != cityCodePre) {
				var layerIdPre = String(cityCodePre) + hazardCode[i];
				map2.setLayerVisibility(layerIdPre,false);
			}

			//レイヤテーブルの表示を切り替え
			if(parent.getElement('layer_R'+hazardCode[i])) {
				parent.getElement('layer_R'+hazardCode[i]).style.display = "";
			}
			if(parent.getElement('layer_R'+hazardCode[i]+'add')) {
				parent.getElement('layer_R'+hazardCode[i]+'add').style.display = "";
			}
			if(parent.getElement('subR'+hazardCode[i])) {
				parent.getElement('subR'+hazardCode[i]).innerHTML = "";
			}

			//レイヤテーブルのチェックを判別してレイヤON-OFF
			if(parent.getElement('R'+hazardCode[i]).checked && parent.document.getElementsByName('R'+hazardCode[i]+'add')[0].checked) { // 愛知県データON
				map2.setLayerVisibility(layerId,false);
				map2.setLayerVisibility(23000+hazardCode[i],true);
				//津波関連の4レイヤ用処理
				if(hazardCode[i]=="601" || hazardCode[i]=="602" || hazardCode[i]=="603" || hazardCode[i]=="604"){
					map2.setLayerVisibility(layerId+"1",false);
					map2.setLayerVisibility(23000+hazardCode[i]+"1",true);
				}
			} else if(parent.getElement('R'+hazardCode[i]).checked) { // 市町村データON
				map2.setLayerVisibility(layerId,true);
				map2.setLayerVisibility(23000+hazardCode[i],false);
				//津波関連の4レイヤ用処理
				if(hazardCode[i]=="601" || hazardCode[i]=="602" || hazardCode[i]=="603" || hazardCode[i]=="604"){
					map2.setLayerVisibility(layerId+"1",true);
					map2.setLayerVisibility(23000+hazardCode[i]+"1",false);
				}
			} else { // レイヤOFF
				map2.setLayerVisibility(layerId,false);
				map2.setLayerVisibility(23000+hazardCode[i],false);
				//津波関連の4レイヤ用処理
				if(hazardCode[i]=="601" || hazardCode[i]=="602" || hazardCode[i]=="603" || hazardCode[i]=="604"){
					map2.setLayerVisibility(layerId+"1",false);
					map2.setLayerVisibility(23000+hazardCode[i]+"1",false);
				}
			}
		} else {	//フラグOFF

			if(parent.getElement('layer_R'+hazardCode[i])) {
				parent.getElement('layer_R'+hazardCode[i]).style.display = "";
			}
			if(parent.getElement('layer_R'+hazardCode[i]+'add')) {
				parent.getElement('layer_R'+hazardCode[i]+'add').style.display = "none";
			}
			if(parent.getElement('subR'+hazardCode[i])) {
				parent.getElement('subR'+hazardCode[i]).innerHTML = "：県データ";
			}

			if(parent.getElement('R'+hazardCode[i]).checked) {
				var layerIdPre = String(cityCodePre) + hazardCode[i];
				map2.setLayerVisibility(layerIdPre,false);
				map2.setLayerVisibility(23000+hazardCode[i],true);
				//津波関連の4レイヤ用処理
				if(hazardCode[i]=="601" || hazardCode[i]=="602" || hazardCode[i]=="603" || hazardCode[i]=="604"){
					map2.setLayerVisibility(layerIdPre+"1",false);
					map2.setLayerVisibility(23000+hazardCode[i]+"1",true);
				}
			} else {
				var layerIdPre = String(cityCodePre) + hazardCode[i];
				map2.setLayerVisibility(layerIdPre,false);
				map2.setLayerVisibility(23000+hazardCode[i],false);
				//津波関連の4レイヤ用処理
				if(hazardCode[i]=="601" || hazardCode[i]=="602" || hazardCode[i]=="603" || hazardCode[i]=="604"){
					map2.setLayerVisibility(layerIdPre+"1",false);
					map2.setLayerVisibility(23000+hazardCode[i]+"1",false);
				}
			}
		}
	}

	//今回処理した市町村コードを保存
	cityCodePre = cityCode;

	searchingflagR = false;		// 検索リクエスト完了
//	console.debug("属性取得自動処理完了（通常）");

}
}


// ページロード時、MyMapOP関数の読み込みを待ってあげる関数（右の人）
function waitLoadFuncR() {

	//if(MyMapOP.Properties.Map) {
	if(map2._map) {
		//alert("fin load map2");

		// ドラッグ後自動処理ON
		tracetoggleR();

		// 中心点属性検索処理ON
		getCenterAttributeR();

		map2.setCenter(parent.map1.getCenterLon(),parent.map1.getCenterLat());
		//alert("set center map1 -> map2 at mapR finish");
		//alert("set scale map1 -> map2 at mapR start : "+parent.map1.getScaleLevel());
		map2.setScaleLevel(parent.map1.getScaleLevel());
		//alert("set scale map1 -> map2 at mapR finish");
				
	} else {
		//alert("waiting map2");
		setTimeout("waitLoadFuncR()", 1000);
	}
}


// ページロード時、MyMapOP関数の読み込みを待ってあげる関数（過去の空中写真つき）
function waitLoadFuncR_AP() {
	//if(MyMapOP.Properties.Map) {
	if(MyMapOP.Map) {
		tracetoggleR();
		getCenterAttributeR();
		map2.setBaseMapVisible(11,1);
	} else {
		setTimeout("waitLoadFuncR_AP()", 1000);
	}
}

// ページロード時、MyMapOP関数の読み込みを待ってあげる関数（土地条件図つき）
function waitLoadFuncR_LC() {
	//if(MyMapOP.Properties.Map) {
	if(MyMapOP.Map) {
		tracetoggleR();
		getCenterAttributeR();
		map2.setBaseMapVisible(3,1);
		map2.setLayerVisibility(23000301, true);
		
		//2017.3.29 背景地図がGoogleMapsだとユーザレイヤのON/OFFが有効にならない不具合への対応
		redrawRightMap();
	} else {
		setTimeout("waitLoadFuncR_LC()", 1000);
	}
}


// シナリオモードEnterキー入力対応
function focusHoldR() {
	parent.focus();
}


//2017.3.29 背景地図がGoogleMapsだとユーザレイヤのON/OFFが有効にならない不具合への対応
function redrawRightMap(){
		map2._map.getLayersByName("ユーザーレイヤ")[0].display(false);
		map2._map.getLayersByName("ユーザーレイヤ")[0].display(true);
		//console.log("redrawRightMap was called");
}
//===============================
//とりあえずscript_r.jsを全部コピー end
//===============================

</script>



<style  scoped>
@import "../../css/Menu.css";
</style>
